export const CustomerIcon = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}>
      <g id="Nav_Icon Group-06 2">
        <path
          id="Vector"
          d="M18.46 21.83C18.33 21.83 18.2 21.78 18.1 21.69C18 21.6 17.95 21.47 17.95 21.33V14.95C17.95 14.06 17.58 13.22 16.95 12.6C16.32 11.98 15.46 11.63 14.58 11.64H9.4C8.51 11.64 7.66 11.98 7.02 12.6C6.39 13.22 6.02 14.07 6.02 14.96V21.34C6.02 21.47 5.96 21.6 5.87 21.7C5.78 21.8 5.65 21.85 5.51 21.84C5.38 21.84 5.25 21.79 5.15 21.7C5.05 21.61 5 21.48 5 21.34V14.96C5.01 13.81 5.48 12.7 6.31 11.89C7.13 11.08 8.25 10.63 9.4 10.64H14.58C15.73 10.63 16.85 11.08 17.67 11.89C18.49 12.7 18.97 13.8 18.98 14.96V21.34C18.98 21.41 18.97 21.47 18.94 21.53C18.91 21.59 18.88 21.65 18.83 21.69C18.78 21.74 18.73 21.77 18.66 21.8C18.6 21.82 18.53 21.84 18.47 21.84L18.46 21.83ZM11.98 9.41C11.12 9.41 10.3 9.08 9.69 8.48C9.08 7.88 8.73 7.06 8.72 6.21C8.73 5.35 9.09 4.54 9.7 3.94C10.31 3.34 11.13 3 11.99 3C12.85 3 13.67 3.34 14.28 3.94C14.89 4.54 15.24 5.36 15.26 6.21C15.26 7.07 14.9 7.88 14.29 8.48C13.68 9.08 12.85 9.41 12 9.41H11.98ZM11.98 4.01C11.39 4.01 10.82 4.23 10.4 4.65C9.98 5.06 9.74 5.62 9.73 6.21C9.74 6.8 9.98 7.36 10.4 7.77C10.82 8.18 11.38 8.41 11.97 8.41C12.56 8.41 13.12 8.18 13.54 7.77C13.96 7.36 14.2 6.8 14.21 6.21C14.21 5.62 13.96 5.06 13.54 4.65C13.12 4.24 12.55 4.01 11.96 4.01H11.98Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
